import { FOfferType, isAvailable, FDealType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.Bed;

export const BED_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.RentLongterm, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'price',
      'withNeighbors',
      'isOwner',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      'parking',
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'dates',
      'price',
      'onlineBooking',
      'withNeighbors',
      'isOwner',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
